import { useEffect, useRef, useState } from "react";
import { animate, useInView } from "framer-motion";

export default function Counter({ value, prefix = "", suffix = "", className = "", testId }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.3 });
  const [n, setN] = useState(value);
  useEffect(() => {
    if (!inView) return undefined;
    const c = animate(0, value, { duration: 2.2, ease: [0.22, 1, 0.36, 1], onUpdate: (v) => setN(Math.round(v)) });
    return () => c.stop();
  }, [inView, value]);
  return (
    <span ref={ref} className={className} data-testid={testId}>
      {prefix}{n.toLocaleString("en-GB")}{suffix}
    </span>
  );
}
